<template>
  <div>
  <div id="defaultId1" :style="{ 'background-color': $store.state.app.themeColor }" class="uBmamJ5">
    <!-- <div id="ge17cd" style="display:none">
    </div> -->
      <RouterDrawe :RouterDrawer="drawer" @closeCloseDialog="clossuoDialog($event)"></RouterDrawe>
    
 <div class="flex_center_start_box" style="flex: 1;">
  <!-- $store.state.app.searchType == 'risk' ? 'u6c4a8 margin-right40 ' :  -->
     <div id="g74a0d" class="u6c4a8 margin-right40">
      <!-- <svg t="1727158932229" class="icon"  viewBox="0 0 1024 1024" version="1.1"
        xmlns="http://www.w3.org/2000/svg" p-id="5681" width="4.28rem" height="3.57rem">
        <path
          d="M334.711467 408.439467c-12.561067 0-24.917333-5.12-33.792-13.994667a48.203093 48.203093 0 0 1-13.994667-33.792c0-12.561067 5.12-24.917333 13.994667-33.792 8.874667-8.874667 21.230933-13.994667 33.792-13.994667 12.561067 0 24.917333 5.12 33.792 13.994667 8.874667 8.874667 13.994667 21.230933 13.994666 33.792 0 12.561067-5.12 24.917333-13.994666 33.792a48.203093 48.203093 0 0 1-33.792 13.994667z m211.285333-13.994667c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792a48.203093 48.203093 0 0 0-33.792-13.994667c-12.561067 0-24.917333 5.12-33.792 13.994667a48.203093 48.203093 0 0 0-13.994667 33.792c0 12.561067 5.12 24.917333 13.994667 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994667 12.561067 0 24.917333-5.12 33.792-13.994667z m177.493333 0c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792a48.203093 48.203093 0 0 0-33.792-13.994667c-12.561067 0-24.917333 5.12-33.792 13.994667a48.203093 48.203093 0 0 0-13.994666 33.792c0 12.561067 5.12 24.917333 13.994666 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994667 12.561067 0 24.917333-5.12 33.792-13.994667z m-354.986666 170.666667c8.874667-8.874667 13.994667-21.230933 13.994666-33.792 0-12.561067-5.12-24.917333-13.994666-33.792a48.203093 48.203093 0 0 0-33.792-13.994667c-12.561067 0-24.917333 5.12-33.792 13.994667a48.203093 48.203093 0 0 0-13.994667 33.792c0 12.561067 5.12 24.917333 13.994667 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994666 12.561067 0 24.917333-5.12 33.792-13.994666z m177.493333 0c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792a48.203093 48.203093 0 0 0-33.792-13.994667c-12.561067 0-24.917333 5.12-33.792 13.994667a48.203093 48.203093 0 0 0-13.994667 33.792c0 12.561067 5.12 24.917333 13.994667 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994666 12.561067 0 24.917333-5.12 33.792-13.994666z m177.493333 0c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792a48.203093 48.203093 0 0 0-33.792-13.994667c-12.561067 0-24.917333 5.12-33.792 13.994667a48.203093 48.203093 0 0 0-13.994666 33.792c0 12.561067 5.12 24.917333 13.994666 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994666 12.561067 0 24.917333-5.12 33.792-13.994666z m-354.986666 170.666666c8.874667-8.874667 13.994667-21.230933 13.994666-33.792 0-12.561067-5.12-24.917333-13.994666-33.792a48.203093 48.203093 0 0 0-33.792-13.994666c-12.561067 0-24.917333 5.12-33.792 13.994666a48.203093 48.203093 0 0 0-13.994667 33.792c0 12.561067 5.12 24.917333 13.994667 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994667 12.561067 0 24.917333-5.12 33.792-13.994667z m177.493333 0c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792a48.203093 48.203093 0 0 0-33.792-13.994666c-12.561067 0-24.917333 5.12-33.792 13.994666a48.203093 48.203093 0 0 0-13.994667 33.792c0 12.561067 5.12 24.917333 13.994667 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994667 12.561067 0 24.917333-5.12 33.792-13.994667z m177.493333 0c8.874667-8.874667 13.994667-21.230933 13.994667-33.792 0-12.561067-5.12-24.917333-13.994667-33.792-8.874667-8.874667-21.162667-13.994667-33.792-13.994666-12.561067 0-24.917333 5.12-33.792 13.994666a48.203093 48.203093 0 0 0-13.994666 33.792c0 12.561067 5.12 24.917333 13.994666 33.792 8.874667 8.874667 21.230933 13.994667 33.792 13.994667 12.561067 0 24.917333-5.12 33.792-13.994667z"
          p-id="5682" fill="#FFFFFF"></path>
      </svg> -->
      <svg t="1750927517285" class="icon margin-left30" @click="drawer = true" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19470" width="33" height="33"><path d="M853.333333 938.666667c-46.933333 0-85.333333-38.4-85.333333-85.333334s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333334 85.333333-38.4 85.333333-85.333334 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333334 85.333333-38.4 85.333333-85.333334 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333334 85.333333 38.4 85.333334 85.333334-38.4 85.333333-85.333334 85.333333z m-341.333333 682.666667c-46.933333 0-85.333333-38.4-85.333333-85.333334s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333334 85.333333 38.4 85.333333 85.333334-38.4 85.333333-85.333333 85.333333zM170.666667 938.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334s38.4-85.333333 85.333334-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333334-85.333333s38.4-85.333333 85.333334-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333334-85.333333s38.4-85.333333 85.333334-85.333334 85.333333 38.4 85.333333 85.333334-38.4 85.333333-85.333333 85.333333z" p-id="19471" fill="#ffffff"></path></svg>

    </div>
    <div class="ub36bc flex_center_start_box u5a174">
       <router-link id="g92f90" class="ub36bc" to="/home?Detail=Trade" v-if="$store.state.app.searchType == 'TradeDetail'">
        <img id="g5e314" style="width: 3em;" src="../../assets/img/logoyanjing.png" alt="" />
    </router-link>
     <router-link id="g92f90" class="ub36bc" to="/" v-else>
        <img id="g5e314" style="width: 3em;" src="../../assets/img/logoyanjing.png" alt="" />
    </router-link>
 
    
    <span v-if="$store.state.app.searchType == 'risk'" class="logon_pingdao">{{ $t('Home.SearchLeads') }}</span>
    <span    v-if="$store.state.app.searchType == 'TradeDetail'" class="logon_pingdao" >Search Trade</span>
          <span    class="logon_pingdao" v-if="$store.state.app.searchType == 'company'">{{ $t('Home.SearchCompanies') }} </span>
  </div>
 </div>
 
    <!-- 贸易    -->
    <div class="topBarBox" v-if="$route.query.Moudles == 'Trade'">
      <div id="g1031d" class="u52ab1">
        <div class="search_left search_left_Trade">
          <el-select v-model="tradeSelect" @change="SelectTrade" :placeholder="placeholderTrade">
            <el-option label="Product" value="HsCode"></el-option>
            <el-option label="Company" value="Company"></el-option>
            <el-option label="Country" value="Country"></el-option>
          </el-select>
        </div>
        <div id="gcb7b3" class="u6e410">
          <el-autocomplete id="c308fb" class="u0fcfc" clearable v-model="searchStr" style="width: 95%;height: auto;"
            :highlight-first-item="true" :debounce="300" :trigger-on-focus="false" :autofocus="true"
            @select="handleSelect" :fetch-suggestions="querySearchAsync" :placeholder="placeholderTrade" size="large">
          </el-autocomplete>
        </div>
        <div id="gfdd55" class="udd32b">
          <svg id="c1217c" class="icon" t="1716874034454" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="4808" width="1.78em" height="1.78em">
            <path id="c8de55"
              d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
              fill="#1A2332" p-id="4809"></path>
          </svg>
        </div>

      </div>
    </div>
    <!-- 公司搜索 -->
    <div class="topBarBox" v-else>
      <div id="g1031d" class="u52ab1">
        <div class="search_left" :class="countryImg ? 'on' : ''">
          <div class="country_flag">
            <img :class="countryImg ? 'country_flag_img' : 'none'" :src="countryImg" />
          </div>
          <el-select v-model="countryCode" ref="select" clearable @clear="clearCountry" :placeholder="$t('Home.selectCountry')"
            popper-class="sel_box sel_Contry" @change="selectCountry" no-match-text="No data" no-data-text="No data">
            <div class="search_sel_container">
              <el-tabs tab-position="left" v-model="tabActiveName">
                <el-tab-pane v-for="(tab, index) in tabCountryList" :key="index">
                  <div slot="label" class="flex_center_between_box">
                    <span class="left_txt">{{ tab.continent.enName }}</span>
                    <span class="right_txt">{{
                      tab.continent.countryNumStr
                    }}</span>
                  </div>
                  <div class="right">
                    <el-option v-for="item in tab.countryList" :key="item.id" :value="item.countryCode" v-show=" item.companyNum>100"
                      :label="item.nameEn" @click.native="labelClick(item.label)">
                      <div class="right_item flex_box">
                        <div class="img flex_center">
                          <img :src="item.urlBanner" />
                        </div>

                        <div class="rBox">
                          <div class="coun_title">{{ item.nameEn }}</div>
                          <div class="coun_num">{{ item.companyNumStr }}</div>
                        </div>
                      </div>
                    </el-option>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-select>
        </div>

        <div id="gfdd55">
          <svg id="idJleBSA" class="icon" t="1716874034454" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="4808" width="1.78em" height="1.78em">
            <path id="idh7f1d4"
              d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
              fill="#8497AB" p-id="4809"></path>
          </svg>
        </div>
        <div id="gcb7b3" class="u6e410">
          <el-input id="gd0275" v-model="searchStr" class="u0fcfc" :placeholder="$t('MyDatabase.Entercompanyname')" size="large"
            clear="" @keydown.enter.native="openList(searchStr)">
          </el-input>
        </div>
        <div class="head_swi_keyword ">
          <!-- :active-color="routeName=='riskNoParams'?'#8E86DD':'#1290C9' " -->
          <el-switch v-model="Keyword" :class="routeName=='riskNoParams'?'aaaa':'bbbb'" 
           @change="switchHeadKeyword"></el-switch>
          <span v-if="Keyword == true" class="switch_txt">{{ $t("Home.keWord") }}</span>
          <span v-else class="switch_txt">{{ $t("Home.firstWord") }}</span>
        </div>

        <div id="gfdd55" class="udd32b" @click="openList(searchStr)">
          <svg id="c1217c" class="icon" t="1716874034454" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="4808" width="1.78em" height="1.78em">
            <path id="c8de55"
              d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
              fill="#1A2332" p-id="4809"></path>
          </svg>
        </div>

      </div>
    </div>



    <div id="gf14a0" class="u942df">
          <div id="cda00e"  v-if="$store.state.app.OperationWarning">
       <el-popover placement="bottom" width="200" trigger="hover" :disabled="!loginStatus" >
        <div class="u9qMull" >Operation Warning</div>
        <svg t="1755585999252" @click="OperationWarningShow" slot="reference" class="icon top_menu_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7131" width="24" height="24"><path d="M512 179.2l390.4 627.2H128l384-627.2m0-64c-19.2 0-44.8 12.8-51.2 32l-390.4 627.2c-25.6 44.8 6.4 96 51.2 96H896c51.2 0 83.2-57.6 51.2-96l-384-627.2c-6.4-19.2-32-32-51.2-32z" fill="#FFC800" p-id="7132"></path><path d="M512 640c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v192c0 19.2-12.8 32-32 32z" fill="#FFC800" p-id="7133"></path><path d="M512 723.2m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z" fill="#FFC800" p-id="7134"></path></svg>
     </el-popover>
      </div>
      <div  id="cda00e"  v-if="userInfo?.userInfo?.userType == '3'"  class="">
        <el-dropdown id="idMW7CnK" class="top_menu_icon" trigger="click" placement="bottom">
          <div id="id1bXcm9">
            <svg @click="loginStatus ? '' : gotoUSer('/')" slot="reference" id="id1wIih1" class="icon "
              t="1708929823979" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18274"
              width="1.987rem" height="1.987rem">
              <path id="idCG1WrO"
                d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                p-id="5361" fill="#FFFFFF"></path>
              <path id="idrrFDpK"
                d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                p-id="5362" fill="#FFFFFF"></path>
            </svg>
          </div>
          <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/userGroup')">Group Account </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/user')">User Account</span> </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/roles')">Roles</span>
            </el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
      </div>
<!-- 超出限制 -->
  

      <el-badge :value="loginStatus ? RedNews.length : ''" :hidden="RedNews.length == 0" class="item">
        <el-popover placement="bottom" width="430" trigger="click" :disabled="!loginStatus"  >
          <div class="cas_panel">
            <div class="flex_center_between_box history_box-headborder">
              <div style="display: flex">
                <h2 class="history_box-head">
                  <el-badge :value="RedNews.length" :hidden="RedNews.length == 0" class="item" type="warning">
                   {{ $t('navigationBar.Notifications') }}
                  </el-badge>
                </h2>
              </div>
            </div>
            <div class="history_box">
              <div class="item_title" v-for="(item, index) in Newlist" :key="index">
                <div class="flex_box" @click="gotomessage(item)">
                  <img src="@/assets/img/csi头像.png" class="messageimg" alt="" />
                  <div class="message-right">
                    <div class="head-text">
                      {{ item.title }}
                    </div>
                    <div class="icon-time">{{ item.createTime }}</div>
                  </div>
                  <div v-if="item.hasRead == 0" class="right-blue"></div>
                </div>
              </div>

            </div>

            <div class="history_box_bottom flex_center_between_box">
              <button class="btn_blue btn_write flex_center" @click="MarkRead()">
                <svg t="1723168823188" class="icontwo" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5443" width="18" height="18">
                  <path
                    d="M921.6 512h-41l92.2 460.8c0 28.3-22.9 51.2-51.2 51.2H102.4c-28.3 0-51.2-22.9-51.2-51.2L143.4 512h-41c-28.3 0-51.2-22.9-51.2-51.2v-51.2c0-28.3 22.9-51.2 51.2-51.2h307.2v-256C409.6 45.8 455.4 0 512 0s102.4 45.8 102.4 102.4v256h307.2c28.3 0 51.2 22.9 51.2 51.2v51.2c0 28.3-22.9 51.2-51.2 51.2zM102.4 972.8h155.2c-3.7-5.5-5.2-12.1-4.1-18.6l31.2-227.6c1.9-14 14.8-23.8 28.8-21.9 14 1.9 23.8 14.8 21.9 28.8-0.1 0.6-0.2 1.3-0.3 1.9l-31 227.6c-0.6 3.5-1.9 6.8-3.9 9.7h621.4L819.2 512H204.8L102.4 972.8z m460.8-870.4c0-28.3-22.9-51.2-51.2-51.2s-51.2 22.9-51.2 51.2v256h102.4v-256z m358.4 307.2H102.4v51.2h819.2v-51.2z"
                    fill="#1A2332" p-id="5444"></path>
                </svg>

          {{ $t('navigationBar.MarkasRead') }}
              </button>
              <button class="btn_blue flex_center" @click="gotoUSer('/account/notifications')">
          {{ $t('navigationBar.Viewall') }}
              </button>
            </div>
          </div>
          <svg @click="loginStatus ? '' : gotoUSer('/')" t="1734672348781" slot="reference" id="idThqehh"
            class="icon top_menu_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="5864" width="1.571rem" height="1.571rem">
            <path
              d="M511.964861 0c101.601754 0 197.851147 35.884083 271.01558 101.043247 71.163116 63.390558 112.4461 147.306253 116.867615 237.03973a39.514379 39.514379 0 0 1 0.372338 5.073106v9.308452c0.093085 1.582437 0.046542 3.211416-0.093085 4.793853v4.002635c-0.279254 104.301205 31.974533 206.089128 93.27069 294.333252l5.910867 8.470691c30.624807 44.07552 32.812293 97.831831 5.864324 143.815584-27.227222 46.402633-79.866518 75.258835-137.439294 75.258835H156.195825c-57.572776 0-110.212072-28.856201-137.439294-75.258835-26.947969-45.983753-24.760482-99.740063 5.864325-143.815584l5.910867-8.470691c61.296156-88.244125 93.549943-190.032048 93.270689-294.333252v-4.374973a31.834906 31.834906 0 0 1-0.093085-2.839078V343.156083c0-1.722064 0.139627-3.397585 0.372338-5.073106 4.421515-89.733477 45.704499-173.60263 116.867615-237.03973C314.160255 35.884083 410.363107 0 511.964861 0z m0 68.277495c-169.506911 0-310.576501 125.012511-314.718763 278.741596v5.724698l0.046542 8.377607c0.279254 117.519207-36.023709 232.152793-105.045881 331.520518l-5.910867 8.470691a67.34665 67.34665 0 0 0-3.025247 74.095278c14.521185 24.807025 41.79495 39.654006 72.88518 39.654006h711.538071c31.09023 0 58.363994-14.846981 72.88518-39.654006a67.34665 67.34665 0 0 0-3.025247-74.095278l-5.910867-8.470691c-69.022172-99.367725-105.325135-214.001312-105.045881-331.520518v-14.102305c-4.095719-153.729085-145.211851-278.741595-314.67222-278.741596z m245.882759 882.394709H266.082101a36.675301 36.675301 0 1 0 0 73.257517h491.765519a36.675301 36.675301 0 1 0 0-73.257517z"
              fill="#FFFFFF" p-id="5865"></path>
          </svg>
        </el-popover>
      </el-badge>

      <el-popover placement="bottom" width="500" trigger="click" :disabled="!loginStatus">
        <div style="padding: 8px">
          <div class="flex_center_start_box">
            <div class="postiverelatibve">
              <img :src="imageUrl" v-if="imageUrl" class="avatar" />
              <div v-else class="avatar avatartex">
                {{ userInfo?.userInfo?.firstName }}
              </div>

              <img v-if="lockType == 1 || lockType == 1" src="../../assets/img/vip.png" class="postiveaboust" />
              <img v-if="lockType == 2 || lockType == 2" src="../../assets/img/jinvip.png" class="postiveaboust" />
            </div>
            <div class="account-left-right">
              <h3>
                {{ userInfo?.userInfo?.firstName
                }}{{ userInfo?.userInfo?.lastName }}
              </h3>
              <h4 v-if="lockType == 2" style="color: #BC8553;">
                {{ $t('navigationBar.GoldSubscriber') }}
              </h4>
              <h4 v-if="lockType == 1" style="color: #7186B1;">
                  {{ $t('navigationBar.SilverSubscriber') }}
              </h4>
              <h4 v-if="lockType == 0">
                Ordinary users
              </h4>
            </div>
          </div>
          <div>
            <div v-if="Vips.length == 0">
              <el-progress :stroke-width="10" class="progress" :percentage="0" :color="'#1290C9'" :show-text="false"
                define-back-color="#DDDDDD"></el-progress>

            </div>
            <div v-for="(item, index) in Vips" :key="index" style="position: relative;">
              <el-progress :stroke-width="10" class="progress" :percentage="(item.dayUsed / (item.totalDays)) * 100"
                :color="item.lockType == 2 ? '#FFA000' : '#1290C9'" :show-text="false"
                define-back-color="#DDDDDD"></el-progress>
              <svg :style="{ position: 'absolute', top: '0px', left: (item.dayUsed / (item.totalDays)) * 100 + '%' }"
                v-if="item.lockType == 1 && Vips.length > 1" t="1727058168966" class="icon" viewBox="0 0 1024 1024"
                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5567" id="mx_n_1727058168967" width="12"
                height="12">
                <path
                  d="M763.776 968.96H261.504C147.456 968.96 55.04 876.544 55.04 762.496V260.224C55.04 146.176 147.456 53.76 261.504 53.76h502.272C877.824 53.76 970.24 146.176 970.24 260.224v502.272c0 114.048-92.416 206.464-206.464 206.464z"
                  fill="#FF4D3C" p-id="5568"></path>
                <path
                  d="M512.64 252.8c-142.592 0-258.56 115.968-258.56 258.56s115.968 258.56 258.56 258.56 258.56-115.968 258.56-258.56-115.968-258.56-258.56-258.56z m-194.688 258.56c0-42.24 13.568-81.152 36.48-113.024l271.36 271.36c-31.872 22.912-70.912 36.48-113.024 36.48-107.52 0-194.816-87.424-194.816-194.816z m352.896 113.152l-271.36-271.36c31.872-22.912 70.912-36.48 113.024-36.48 107.392 0 194.688 87.424 194.688 194.688 0.128 42.24-13.44 81.152-36.352 113.152z"
                  fill="#FFFFFF" p-id="5569"></path>
              </svg>

              <h4 v-if="item.lockType == 2" class="ExpireDate">{{ $t('navigationBar.Goldsubscriptiondate') }} : {{ item.endTime }} ({{
                item.dayUsed }}/{{ item.totalDays }})</h4>
              <h4 v-else class="ExpireDate">{{ $t('navigationBar.Silversubscriberdate') }} :{{ item.endTime }} ({{ item.dayUsed }}/{{
                item.totalDays }})</h4>
            </div>

            <div class="Available flex_center_start_box">
              <img src="../../assets/img/jifen.png" alt="" class="margin10" />{{ $t('navigationBar.AvailableCredits') }}: {{
                $store.state.app.equityType }}
            </div>
            <button v-if="userInfo?.userInfo?.userType != 2" style="width: 100%" @click="gotoUSer('/index/addCredit')"
              class="btn_blue flex_center">
           {{ $t('navigationBar.AddCredits') }}
            </button>
          </div>
        </div>

        <svg @click="loginStatus ? '' : gotoUSer('/')" slot="reference" id="idONDSqC" class="icon top_menu_icon"
          t="1716880662137" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859"
          height="1.99rem" width="1.99rem">
          <path id="idRwKoi7"
            d="M512 896c212.078933 0 384-171.921067 384-384s-171.921067-384-384-384-384 171.921067-384 384 171.921067 384 384 384z m0 42.666667c-235.639467 0-426.666667-191.0272-426.666667-426.666667S276.360533 85.333333 512 85.333333s426.666667 191.0272 426.666667 426.666667-191.0272 426.666667-426.666667 426.666667z"
            fill="#ffffff" p-id="5860"></path>
          <path id="id19vpOq"
            d="M512 797.866667c157.879467 0 285.866667-127.9872 285.866667-285.866667s-127.9872-285.866667-285.866667-285.866667-285.866667 127.9872-285.866667 285.866667 127.9872 285.866667 285.866667 285.866667z m0 42.666666c-181.444267 0-328.533333-147.089067-328.533333-328.533333s147.089067-328.533333 328.533333-328.533333 328.533333 147.089067 328.533333 328.533333-147.089067 328.533333-328.533333 328.533333z"
            fill="#ffffff" p-id="5861"></path>
          <path id="id3SVEJN"
            d="M533.333333 683.968c41.365333-10.346667 72.644267-47.044267 74.210134-91.7888 1.890133-54.161067-40.4864-99.605333-94.651734-101.495467a21.589333 21.589333 0 0 0-2.133333 0.029867 21.589333 21.589333 0 0 0-2.129067-0.1792c-28.258133-0.989867-50.368-24.695467-49.3824-52.957867 0.9856-28.258133 24.695467-50.368 52.957867-49.3824 28.258133 0.989867 50.368 24.695467 49.378133 52.957867a21.333333 21.333333 0 0 0 42.641067 1.489067c1.578667-45.047467-28.864-83.7888-70.890667-94.3232V328.533333a21.333333 21.333333 0 1 0-42.666666 0v19.042134c-41.088 8.8064-72.5248 44.612267-74.0608 88.512-1.809067 51.810133 38.724267 95.274667 90.5344 97.088 0.721067 0.0256 1.4336 0.0128 2.133333-0.034134 0.699733 0.093867 1.408 0.157867 2.133333 0.183467 30.613333 1.066667 54.562133 26.752 53.495467 57.365333-1.066667 30.6176-26.752 54.570667-57.3696 53.499734-30.613333-1.066667-54.5664-26.752-53.495467-57.3696a21.333333 21.333333 0 1 0-42.641066-1.489067c-1.706667 48.917333 32.6912 90.722133 79.2704 99.754667V704a21.333333 21.333333 0 1 0 42.666666 0v-20.032z"
            fill="#ffffff" p-id="5862"></path>
        </svg>
      </el-popover>


      <div id="cda00e" class="                   ">
        <el-dropdown id="idMW7CnK" trigger="click" class="top_menu_icon" placement="bottom">
          <div id="id1bXcm9">
            <svg @click="loginStatus ? '' : gotoUSer('/')" t="1724132771458" slot="reference" class="icon "
              viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5604"
              width="1.9291262135922rem" height="1.9291262135922rem">
              <path
                d="M257.706667 343.04h184.32V392.533333h-124.586667v69.973334h105.813333v51.2h-105.813333v80.213333h129.706667v51.2H257.706667V343.04zM506.88 343.04h61.44l87.04 160.426667 30.72 64.853333h1.706667c-3.413333-30.72-8.533333-71.68-8.533334-105.813333v-119.466667h56.32v302.08h-61.44l-87.04-162.133333-30.72-64.853334h-1.706666c3.413333 32.426667 6.826667 69.973333 6.826666 105.813334v121.173333h-56.32V343.04z"
                fill="#ffffff" p-id="5605"></path>
              <path
                d="M498.346667 933.546667C250.88 933.546667 51.2 732.16 51.2 486.4S250.88 39.253333 498.346667 39.253333 945.493333 238.933333 945.493333 486.4c0 37.546667-5.12 73.386667-13.653333 109.226667-3.413333 13.653333-17.066667 22.186667-30.72 18.773333-13.653333-3.413333-22.186667-17.066667-18.773333-30.72 8.533333-30.72 11.946667-63.146667 11.946666-97.28C894.293333 267.946667 716.8 90.453333 498.346667 90.453333S102.4 267.946667 102.4 486.4s177.493333 395.946667 395.946667 395.946667c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6z"
                fill="#ffffff" p-id="5606"></path>
              <path
                d="M947.2 795.306667H629.76c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h264.533333l-30.72-39.253334c-8.533333-11.946667-6.826667-27.306667 5.12-35.84 10.24-8.533333 27.306667-6.826667 35.84 5.12l64.853334 81.92c6.826667 8.533333 6.826667 18.773333 3.413333 27.306667s-15.36 11.946667-25.6 11.946667zM694.613333 983.04c-6.826667 0-15.36-3.413333-20.48-10.24l-64.853333-81.92c-6.826667-8.533333-6.826667-18.773333-3.413333-27.306667s13.653333-13.653333 22.186666-13.653333h317.44c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6H682.666667l30.72 39.253333c8.533333 11.946667 6.826667 27.306667-5.12 35.84-3.413333 5.12-8.533333 6.826667-13.653334 6.826667z"
                fill="#ffffff" p-id="5607"></path>
            </svg>
          </div>
          <el-dropdown-menu id="idKKFx11" class="uWDPJiJ" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu" v-for="(item, index) in languageList" :key="index">
              <!--  -->
              <button id="cf870f" class="u606de"   :disabled="item.countryName == 'Japanese'" @click="selectLanguage(item)">
                <div style="display: flex;align-items: center;">
                  <img
                    style="width: 2.142857142857143rem;height: 1.4285714285714286rem;margin-right: 0.7142857142857143rem;"
                    :src="require('../../../static' + getCountryImgUrl(item.countryCodeImg))" alt="">
                  <div :class="item.color ? 'activecolor' : ''">
                    {{ item.countryName }}
                  </div>
                </div>
      
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div id="cda00e" class="                   ">
        <el-dropdown id="idMW7CnK" trigger="click" class="top_menu_icon" placement="bottom">
          <div id="id1bXcm9">
            <svg @click="loginStatus ? '' : gotoUSer('/')" id="idt2sf8o" class="icon " t="1716880814641"
              viewBox="0 0 1059 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6322" width="1.642rem"
              height="1.642rem">
              <path id="ideS7NJF"
                d="M547.326184 788.934951m-54.851338 0a54.851338 54.851338 0 1 0 109.702676 0 54.851338 54.851338 0 1 0-109.702676 0Z"
                p-id="6323"></path>
              <path id="id6USgFp"
                d="M547.326184 184.213435c-100.826964 0-182.856638 81.294743-182.856638 181.217175a36.576981 36.576981 0 0 0 73.153962 0c0-60.603591 48.194554-108.063213 109.702676-108.063213 60.490525 0 109.71681 49.59375 109.716809 110.550674 0 24.394076-30.612728 54.964405-60.193725 84.587802-40.378839 40.336439-86.085932 86.043532-86.085932 145.883925v61.847321a36.576981 36.576981 0 1 0 73.139829 0v-61.889721c0-29.510331 32.84579-62.356121 64.659848-94.08538 40.110306-40.124439 81.619809-81.591542 81.619809-136.343947 0-101.307496-82.029674-183.704636-182.856638-183.704636z"
                p-id="6324"></path>
              <path id="idZjrVBt"
                d="M547.326184 0C264.999379 0 35.333251 229.666128 35.333251 511.992933a509.10974 509.10974 0 0 0 90.241121 289.972921L6.656784 967.071067A35.333251 35.333251 0 0 0 35.333251 1023.038936l466.031441-0.183733v0.268532c15.687963 0.240266 30.471395 0.862131 45.961492 0.862132 282.326805 0 512.007067-229.666128 512.007067-511.992934S829.667122 0 547.326184 0z m11.377307 950.379639l-4.395457 0.0848c-2.317861 0-5.215188 0.282666-7.547182 0.409866-17.313293 0.890398-29.67993 1.158931-45.39616 1.045864v0.282666l-397.018537 0.1696 95.187777-132.146357a35.333251 35.333251 0 0 0-3.476792-45.424427l0.240267-0.2544a436.238444 436.238444 0 0 1-87.485129-262.526051C108.812278 270.214567 305.533684 73.493161 547.340317 73.493161s438.513906 196.693139 438.513906 438.499772c0 237.976509-190.61582 432.32352-427.150732 438.386706z"
                p-id="6325"></path>
            </svg>
          </div>
          <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/fAQ')">{{ $t('AccountCenterMenu.FAQ') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/privacyPolicy')">{{ $t('AccountCenterMenu.Privacy') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/terms')">{{ $t('AccountCenterMenu.Terms') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull"
                @click="lockType == 0 ? $bus.$emit('show-permission-dialog', '您没有权限访问该功能！') : gotoUSer('/account/reportaproblem')">
               {{ $t('AccountCenterMenu.ReportIssues') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull"
                @click="lockType != 2 ? $bus.$emit('show-permission-dialog', '您没有权限访问该功能！') : gotoUSer('/account/instructions')">  {{ $t('AccountCenterMenu.UserGuide') }}
              </span></el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/About')"> {{ $t('AccountCenterMenu.AboutCSI') }}
              </span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div id="cda00e" :class="loginStatus ? 'u1ba31  icon top_menu_icon' : ' icon top_menu_icon'
        " @click="loginStatus ? '' : gotoUSer('/')">
        <el-dropdown id="idMW7CnK" trigger="click" class="xialakuang" placement="bottom">
          <div id="id1bXcm9">
            <svg id="idxPwMuF" v-show="headPortrait" class="icon" t="1716880974917" viewBox="0 0 1024 1024"
              version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7415" width="1.71em" height="1.71em">
              <path id="iddvqpfq" d="M540.842397 542.300097" p-id="7416"></path>
              <path id="id7VqerN"
                d="M256.722454 336.343351c0-137.247874 113.578802-248.478188 253.686816-248.478188 140.119271 0 253.686816 111.230314 253.686816 248.478188 0 137.226385-113.567545 248.473071-253.686816 248.473071C370.307396 584.821539 256.722454 473.568712 256.722454 336.343351L256.722454 336.343351 256.722454 336.343351zM211.951785 336.343351c0 117.863385 71.251787 219.473597 173.847443 265.72806-172.775019 48.938596-302.560944 197.078541-320.840262 377.394303l44.989657 0c22.275329-197.319018 193.054901-350.796528 400.459624-350.796528s378.189412 153.476487 400.460648 350.796528l44.989657 0C937.591513 799.148929 807.793308 651.010007 635.020336 602.071412c102.594633-46.249347 173.85256-147.864676 173.85256-265.72806 0-161.450089-133.629463-292.324812-298.462602-292.324812C345.572038 44.017516 211.951785 174.888146 211.951785 336.343351L211.951785 336.343351 211.951785 336.343351zM211.951785 336.343351"
                p-id="7417"></path>
            </svg>
            <div v-if="loginStatus" class="avatarnologin">
              <img id="g87fee" :src="imageUrl" v-if="imageUrl" class="avatarnologin" />
              <div v-else class="avatar avatartex avatarnologin">

                <div class="avatar_content">
                  {{ userInfo?.userInfo?.firstName }}
                </div>

              </div>
            </div>
            <div v-else>
              <div id="ga2883">
                <div id="g7b8d7" class="u0427c">
                  <div id="gc941a" class="u84443" v-if="!loginStatus">
                    {{ loginStatus ? $t('MyAccount.SignOut') : "Sign in" }}
                  </div>

                  <div id="g7e8e5" class="ubbf89">
                    <svg t="1727149438668" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5432" width="21" height="21">
                      <path
                        d="M899.64 897.715c-7.238-108.133-60.68-208.738-146.61-276.032l-5.165-3.568-0.047 0.07c-4.887-2.989-10.458-4.587-16.193-4.587-19.702 0-31.458 9.498-31.458 25.412 0 9.266 4.285 17.975 11.477 23.883l-0.08 0.139 4.562 3.266c72.065 51.519 112.638 129.653 120.584 232.273l0.085 1.12a31.507 31.507 0 0 0-0.116 2.612c0 17.341 14.058 31.4 31.4 31.4 16.76 0 30.45-13.13 31.35-29.665h0.624l-0.412-6.323z m-101.124-525.92c0-156.107-128.53-283.118-286.525-283.118S225.465 215.688 225.465 371.796c0 84.11 37.191 162.57 102.378 216.66-117.017 62.453-194.688 181.59-203.48 313.119l-0.362 5.483c-0.007 0.113-0.016 0.226-0.022 0.34l-0.033 0.5h0.02c-0.009 0.267-0.02 0.533-0.02 0.802 0 14.703 11.918 26.622 26.622 26.622 14.703 0 26.623-11.918 26.623-26.622 0-0.27-0.013-0.535-0.02-0.802h0.554l0.417-5.468c9.648-124.998 88.871-234.45 202.112-279.553 33.81 15.706 85.42 32.06 131.715 32.06 42.89 0 84.54-9.45 124.199-28.307l29.049-16.863 23.72-15.567c69.63-54.203 109.579-135.28 109.579-222.404zM511.99 597.932c-126.248 0-228.95-101.462-228.95-226.158 0-124.673 102.701-226.112 228.95-226.112 126.26 0 228.973 101.439 228.973 226.112-0.001 124.696-102.714 226.158-228.973 226.158z"
                        p-id="5433" fill="#FFFFFF"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu">
              <div style="padding: 0.7142857142857143rem 0rem">
                <div class="flex_center_star">
                  <div class="postiverelatibve"
                    style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;">
                    <img :src="imageUrl" v-if="imageUrl" class="avatarnologin"
                      style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;" />
                    <div v-else class="avatar avatartex"
                      style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;overflow: hidden;">
                      {{ userInfo?.userInfo?.firstName }}
                    </div>
                    <img v-if="lockType == 1" src="../../assets/img/vip.png" class="postiveaboust" />
                    <img v-if="lockType == 2" src="../../assets/img/jinvip.png" class="postiveaboust" />

                  </div>
                  <div class="account-left-right">
                    <h3>
                      {{ userInfo?.userInfo?.firstName }} {{ userInfo?.userInfo?.lastName }}
                    </h3>
             
                    <h4 v-if="userInfo?.userInfo?.userType == '1'">
                       {{ $t('navigationBar.IndivdualAccount') }}
                    </h4>
                    <h4 v-else>
                      {{ $t('navigationBar.GroupAccount') }}
                    </h4>
                  </div>
                </div>
              </div>
            </el-dropdown-item>
            <div class="henggang"></div>
            <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
              <svg t="1723629044985" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5445" width="2.14rem" height="2.14rem">
                <path
                  d="M899.64 897.715c-7.238-108.133-60.68-208.738-146.61-276.032l-5.165-3.568-0.047 0.07c-4.887-2.989-10.458-4.587-16.193-4.587-19.702 0-31.458 9.498-31.458 25.412 0 9.266 4.285 17.975 11.477 23.883l-0.08 0.139 4.562 3.266c72.065 51.519 112.638 129.653 120.584 232.273l0.085 1.12a31.507 31.507 0 0 0-0.116 2.612c0 17.341 14.058 31.4 31.4 31.4 16.76 0 30.45-13.13 31.35-29.665h0.624l-0.412-6.323z m-101.124-525.92c0-156.107-128.53-283.118-286.525-283.118S225.465 215.688 225.465 371.796c0 84.11 37.191 162.57 102.378 216.66-117.017 62.453-194.688 181.59-203.48 313.119l-0.362 5.483c-0.007 0.113-0.016 0.226-0.022 0.34l-0.033 0.5h0.02c-0.009 0.267-0.02 0.533-0.02 0.802 0 14.703 11.918 26.622 26.622 26.622 14.703 0 26.623-11.918 26.623-26.622 0-0.27-0.013-0.535-0.02-0.802h0.554l0.417-5.468c9.648-124.998 88.871-234.45 202.112-279.553 33.81 15.706 85.42 32.06 131.715 32.06 42.89 0 84.54-9.45 124.199-28.307l29.049-16.863 23.72-15.567c69.63-54.203 109.579-135.28 109.579-222.404zM511.99 597.932c-126.248 0-228.95-101.462-228.95-226.158 0-124.673 102.701-226.112 228.95-226.112 126.26 0 228.973 101.439 228.973 226.112-0.001 124.696-102.714 226.158-228.973 226.158z"
                  p-id="5446" fill="#1A2332"></path>
              </svg>
              <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/myAccount')">  {{ $t('AccountCenterMenu.Account') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
              <svg t="1723629413656" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="6188" id="mx_n_1723629413658" width="1.92rem" height="1.92rem">
                <path
                  d="M85.333333 34.133333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V68.266667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V68.266667a68.266667 68.266667 0 0 1 68.266666-68.266667z m119.466667 136.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333-324.266667a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m-136.533333 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333 34.133333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4zM85.333333 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V426.666667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V426.666667a68.266667 68.266667 0 0 1 68.266666-68.266667z m0 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V785.066667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V785.066667a68.266667 68.266667 0 0 1 68.266666-68.266667z"
                  fill="#1A2332" p-id="6189"></path>
              </svg>
              <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/companiesViewed?type=1')"> {{ $t('AccountCenterMenu.MyDatabase') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7" v-if="userInfo?.userInfo?.userType == '3'">
              <svg t="1733991316703" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="9598" width="2.14rem" height="2.14rem">
                <path
                  d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                  p-id="9599" fill="#1A2332"></path>
                <path
                  d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                  p-id="9600" fill="#1A2332"></path>
              </svg>
              <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/userGroup')">{{ $t('AccountCenterMenu.OrganizationalManagement') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="ceec8d" class="ubgvGhd xiao">
              <svg t="1733991386099" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="10214" id="mx_n_1733991386100" width="2rem" height="2rem">
                <path
                  d="M512 896c212.078933 0 384-171.921067 384-384s-171.921067-384-384-384-384 171.921067-384 384 171.921067 384 384 384z m0 42.666667c-235.639467 0-426.666667-191.0272-426.666667-426.666667S276.360533 85.333333 512 85.333333s426.666667 191.0272 426.666667 426.666667-191.0272 426.666667-426.666667 426.666667z"
                  fill="#1A2332" p-id="10215"></path>
                <path
                  d="M512 797.866667c157.879467 0 285.866667-127.9872 285.866667-285.866667s-127.9872-285.866667-285.866667-285.866667-285.866667 127.9872-285.866667 285.866667 127.9872 285.866667 285.866667 285.866667z m0 42.666666c-181.444267 0-328.533333-147.089067-328.533333-328.533333s147.089067-328.533333 328.533333-328.533333 328.533333 147.089067 328.533333 328.533333-147.089067 328.533333-328.533333 328.533333z"
                  fill="#1A2332" p-id="10216"></path>
                <path
                  d="M533.333333 683.968c41.365333-10.346667 72.644267-47.044267 74.210134-91.7888 1.890133-54.161067-40.4864-99.605333-94.651734-101.495467a21.589333 21.589333 0 0 0-2.133333 0.029867 21.589333 21.589333 0 0 0-2.129067-0.1792c-28.258133-0.989867-50.368-24.695467-49.3824-52.957867 0.9856-28.258133 24.695467-50.368 52.957867-49.3824 28.258133 0.989867 50.368 24.695467 49.378133 52.957867a21.333333 21.333333 0 0 0 42.641067 1.489067c1.578667-45.047467-28.864-83.7888-70.890667-94.3232V328.533333a21.333333 21.333333 0 1 0-42.666666 0v19.042134c-41.088 8.8064-72.5248 44.612267-74.0608 88.512-1.809067 51.810133 38.724267 95.274667 90.5344 97.088 0.721067 0.0256 1.4336 0.0128 2.133333-0.034134 0.699733 0.093867 1.408 0.157867 2.133333 0.183467 30.613333 1.066667 54.562133 26.752 53.495467 57.365333-1.066667 30.6176-26.752 54.570667-57.3696 53.499734-30.613333-1.066667-54.5664-26.752-53.495467-57.3696a21.333333 21.333333 0 1 0-42.641066-1.489067c-1.706667 48.917333 32.6912 90.722133 79.2704 99.754667V704a21.333333 21.333333 0 1 0 42.666666 0v-20.032z"
                  fill="#1A2332" p-id="10217"></path>
              </svg>
              <!-- lockType == 0 ? $bus.$emit('show-permission-dialog', '您没有权限访问该功能！') : -->
              <span id="cb4014" class="u9qMull"
              
                @click=" gotoUSer('/account/invoiceDownload')">{{ $t('AccountCenterMenu.BillingandPayment') }}
              </span>
            </el-dropdown-item>

            <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
              <svg t="1733991430414" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="10527" width="2rem" height="2rem">
                <path
                  d="M942.08 519.68c0-33.28-2.56-61.44-10.24-81.92 2.56-20.48-10.24-35.84-30.72-40.96h-2.56c-35.84-7.68-61.44-25.6-81.92-61.44-17.92-30.72-23.04-66.56-10.24-99.84 7.68-15.36 2.56-35.84-12.8-48.64-38.4-35.84-87.04-64-140.8-81.92-15.36-7.68-35.84-2.56-48.64 12.8-23.04 28.16-56.32 43.52-94.72 43.52-33.28 0-66.56-15.36-94.72-43.52-17.92-17.92-35.84-15.36-48.64-12.8-56.32 20.48-99.84 46.08-135.68 79.36-17.92 10.24-23.04 30.72-15.36 46.08 10.24 38.4 7.68 74.24-10.24 104.96-15.36 30.72-46.08 51.2-81.92 61.44-2.56 0-5.12 0-5.12 2.56-12.8 7.68-23.04 17.92-25.6 30.72v2.56c-5.12 28.16-10.24 53.76-10.24 84.48 0 33.28 2.56 61.44 10.24 81.92-2.56 15.36 5.12 30.72 28.16 40.96h2.56c35.84 7.68 61.44 25.6 81.92 61.44 17.92 30.72 23.04 66.56 10.24 99.84-7.68 15.36-2.56 35.84 12.8 48.64 35.84 33.28 84.48 64 140.8 84.48h2.56c2.56 0 2.56 2.56 5.12 2.56h5.12c12.8 0 25.6-5.12 35.84-15.36 23.04-28.16 56.32-43.52 94.72-43.52 33.28 0 66.56 15.36 94.72 43.52 10.24 10.24 20.48 15.36 33.28 15.36 5.12 0 12.8 0 17.92-2.56 58.88-23.04 99.84-48.64 138.24-81.92 15.36-10.24 23.04-30.72 15.36-46.08-10.24-38.4-7.68-74.24 10.24-104.96 15.36-30.72 46.08-51.2 81.92-61.44 2.56 0 5.12 0 5.12-2.56 12.8-7.68 23.04-17.92 25.6-30.72v-2.56c5.12-28.16 7.68-56.32 7.68-84.48zM140.8 445.44c48.64-12.8 89.6-43.52 112.64-84.48 23.04-43.52 30.72-92.16 17.92-140.8 33.28-28.16 71.68-51.2 117.76-69.12 38.4 35.84 81.92 56.32 130.56 56.32 51.2 0 99.84-20.48 130.56-56.32 43.52 15.36 81.92 38.4 115.2 69.12-12.8 51.2-7.68 99.84 17.92 140.8 23.04 43.52 61.44 74.24 110.08 87.04 5.12 20.48 7.68 46.08 7.68 71.68 0 20.48-2.56 40.96-7.68 69.12-51.2 15.36-89.6 46.08-110.08 87.04-23.04 43.52-30.72 92.16-17.92 140.8-33.28 28.16-71.68 51.2-117.76 69.12-38.4-35.84-84.48-53.76-130.56-53.76-51.2 0-97.28 20.48-130.56 56.32-43.52-15.36-81.92-38.4-115.2-69.12 12.8-51.2 7.68-99.84-17.92-140.8-23.04-43.52-61.44-74.24-110.08-87.04-5.12-20.48-7.68-48.64-7.68-71.68-2.56-25.6 0-46.08 5.12-74.24z"
                  p-id="10528" fill="#1A2332"></path>
                <path
                  d="M670.72 463.36c-5.12-12.8-17.92-20.48-30.72-17.92-12.8 5.12-20.48 20.48-15.36 33.28 7.68 20.48 7.68 46.08 0 74.24-10.24 28.16-30.72 51.2-56.32 66.56-28.16 12.8-58.88 15.36-87.04 5.12-28.16-10.24-51.2-30.72-66.56-56.32-12.8-28.16-15.36-58.88-5.12-87.04 10.24-28.16 30.72-51.2 56.32-66.56 28.16-12.8 58.88-15.36 87.04-5.12 12.8 5.12 28.16-2.56 33.28-15.36 5.12-12.8-2.56-28.16-15.36-33.28-40.96-15.36-87.04-12.8-128 7.68s-71.68 53.76-84.48 94.72c-15.36 40.96-12.8 87.04 7.68 128s53.76 71.68 94.72 84.48c15.36 5.12 35.84 10.24 53.76 10.24 71.68 0 133.12-46.08 156.16-112.64 10.24-38.4 10.24-74.24 0-110.08z"
                  p-id="10529" fill="#1A2332"></path>
              </svg>
              <span id="id92hCgF" class="u9qMull"
                @click="lockType == 0 ? $bus.$emit('show-permission-dialog', '您没有权限访问该功能！') : gotoUSer('/account/UserSettings')">{{ $t('AccountCenterMenu.UserSettings') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
              <svg t="1733991466296" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="10827" width="2rem" height="2rem">
                <path
                  d="M506.550742 1024h-3.232833a242.46251 242.46251 0 0 1-173.225993-75.702184 26.940279 26.940279 0 1 1 39.063404-37.177584A188.581952 188.581952 0 0 0 645.023776 909.773218 26.940279 26.940279 0 0 1 684.895388 945.873191a244.078927 244.078927 0 0 1-178.344646 78.126809zM900.956425 834.879242h-781.268087a94.290976 94.290976 0 0 1 0-188.581952 13.739542 13.739542 0 0 0 13.739542-13.470139v-255.663247a377.163904 377.163904 0 0 1 754.327808 0v255.663247a13.739542 13.739542 0 0 0 13.739542 13.470139 94.290976 94.290976 0 0 1 0 188.581952zM510.322381 56.843988A323.283346 323.283346 0 0 0 187.039035 377.163904v255.663247a67.6201 67.6201 0 0 1-67.6201 67.350697 40.410418 40.410418 0 0 0 0 80.820837h781.268087a40.410418 40.410418 0 0 0 0-80.820837 67.6201 67.6201 0 0 1-67.081294-67.350697v-255.663247A323.283346 323.283346 0 0 0 510.322381 56.843988z"
                  fill="#1A2332" p-id="10828"></path>
              </svg>
              <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/notifications')">{{ $t('AccountCenterMenu.Messages') }}
              </span>
            </el-dropdown-item>

            <div id="g2bc16" class="henggang"></div>
            <el-dropdown-item id="cf0560" class="ubgvGhd sign">
              <svg id="id2MZcZM" class="icon uc68vlP" t="1719479218530" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5906" width="2.14rem" height="2.14rem">
                <path id="idZPpQuP"
                  d="M514.616594 860.266915c-200.014406 0-362.737488-162.724105-362.737488-362.738511 0-111.74606 50.379411-215.605499 138.222061-284.947797 5.988388-4.727675 14.676257-3.705392 19.402909 2.282996 4.727675 5.988388 3.705392 14.675234-2.282996 19.402909-81.162508 64.070224-127.711683 160.024623-127.711683 263.261892 0 184.779424 150.328797 335.109244 335.108221 335.109244 184.78147 0 335.112314-150.328797 335.112314-335.109244 0-103.307877-46.587038-199.285812-127.815037-263.323291-5.991458-4.723581-7.019881-13.409404-2.296299-19.400862 4.724605-5.991458 13.412474-7.017834 19.400862-2.296299 87.917352 69.309552 138.339742 173.195597 138.339742 285.020452C877.359198 697.54281 714.633047 860.266915 514.616594 860.266915zM514.676969 443.88567c-7.629771 0-13.814634-6.184863-13.814634-13.814634L500.862335 157.74572c0-7.629771 6.184863-13.814634 13.814634-13.814634s13.814634 6.184863 13.814634 13.814634l0 272.325315C528.491603 437.700807 522.30674 443.88567 514.676969 443.88567z"
                  fill="#1A2332" p-id="5907"></path>
              </svg>
              <span id="c2ced8" class="u9qMull uuXabem" @click="signOutAccount">{{  $t('MyAccount.SignOut') }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div id="g87c30" @click="AIseach()" class="u6f58a">
        <img id="g61a71" class="u81734" src="../../assets/images/chart2.png" alt="" />
      </div>
   
    </div>
       

  </div>
   <OperationWarning ></OperationWarning>
  </div>
  <!--srcviewslayoutheadervuehtmlEnd-->
</template>

<script>
import { mixins1 } from "@/mixins/index";
import { getCountryCollection, getUserSimpleInfo } from "@/api/companyApi.js";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import { getNotificationList, markAllAsRead,companyView} from '@/api/userApi.js';
import { searchCompany, productSearch, searchTradeHscode } from "@/api/searchApi.js";
import RouterDrawe from '../../components/router-drawer/drawer.vue'
import OperationWarning from "../../components/power/OperationWarning.vue";
import { mapGetters } from 'vuex'


export default {
  mixins: [mixins1],
  name: "",
  props: {

  },
  components: {
    RouterDrawe,
    OperationWarning,
    
  },
   computed: {
    ...mapGetters({
      lang: 'app/lang'
    })
  },
    
  created() {
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    bus.$on("handleLogin", (loginCheck) => {
      this.loginStatus = loginCheck;
      this.$router.go(0)

    });
    if (this.token) {
     this.companyViewPower()

      this.imageUrl = JSON.parse(localStorage.getItem('userInfoImg')) == undefined ? this.imageUrl : JSON.parse(localStorage.getItem('userInfoImg'))
      this.getUserSimpleInfoList()

    }
    this.getAllCountry();
  },

  mounted() {
    if (this.$route.params.search) {
      this.searchStr = this.$route.params.search;
    }
  },
 
  watch: {
    '$store.state.app.NotificationsList': {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        // if (newVal=true) {
        this.Newlist = []
        this.RedNews = []
        if (this.token) {
          this.getNotificationListDetali()

        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    '$store.state.app.labelCode': {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        // if(newVal!=''){
        if (newVal != '') {
          this.searchStr = ''
        }

      
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    '$route.name':{
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        // if(newVal!=''){
       this.routeName=newVal
       
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    }
  },
  data() {
    return {
      Newlist: [],
      AvailablePoints: 0,
      percentage: 0,
      percentagejin: 0,
      routeName:'companylistSearch',
      ExpireDate: '',
      Keyword: this.$route.query.keword == 2||this.$route.query.keword==undefined ? true : false,
      drawer: false,
      // selectName
      selectName: "Personal",
      // searchStr
      searchStr: "",
      // selectValue
      selectValue: "Keywork",
      tradeSelect: 'HsCode',
      placeholderTrade: "Search by",
  
      Vips: [],
    languageList: [
        {
          countryCode: 'en',
          countryCodeImg:'GB',
          countryName: 'English',
          color: true

        },
        {
          countryCode: 'jp',
            countryCodeImg:'JP',
          countryName: 'Japanese',
          color: false

        },
        // {
        //   countryCode:'de',
        //   countryCodeImg:'DE',
        //   countryName:'German',

        // },
        // {
        //   countryCode:'fr',
        //  countryCodeImg:'FR',
        //   countryName:'France',

        // },
         
        //  {
        //   countryCode:'es',
        //  countryCodeImg:'ES',
        //   countryName:'Spain',

        // },
        //  {
        //   countryCode:'it',
        //  countryCodeImg:'IT',
        //   countryName:'Italy',

        // },
        //  {
        //   countryCode:'nl',
        //  countryCodeImg:'NL',
        //   countryName:'Netherlands',

        // },
        // {
        //   countryCode:'pt',
        //  countryCodeImg:'PT',
        //   countryName:'Portugal',

        // },
        

      ],
      // handleQueryloading
      handleQueryloading: false,
      // headPortrait
      headPortrait: false,
      countryImg: "",
      countryCode: "",
      countryCode1: "",
      tabCountryList: [],
      RedNews: [],
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      isNotice: true, //通知高亮
      loginStatus: false,
      lockType: 0,
      token: localStorage.getItem("token"),
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,

    };
  },
  methods: {
     selectLanguage(item){
      this.languageList.map(ite=>{
        if(ite.countryCode==item.countryCode){
          ite.color=true
        }else{
          ite.color=false
        }
      })

 this.$i18n.locale=item.countryCode
 sessionStorage.setItem('language',  this.$i18n.locale)
         this.$store.dispatch("app/setLang", this.$i18n.locale)
   
    },
       companyViewPower(){
      companyView({
        id3a:this.$route.query.id3a
      }).then(res=>{
        if(!res.data){
                this.$store.dispatch("app/SetOperationWarning", true)
          // this.$bus.$emit('show-OperationWaring-dialog', '');
          
        }
      })
    },
    OperationWarningShow(){
      this.$bus.$emit('show-OperationWaring-dialog', '');
    },
    switchHeadKeyword() {

    },
    // 选择贸易频道
    SelectTrade() {
      this.searchStr = ''
    },
    //贸易搜索下拉
    handleSelect(item) {
      let SACode1 = "";
      if (this.tradeSelect == 'Company') {
        sessionStorage.setItem("company", JSON.stringify(item));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList;

        newscountry.map((ite) => {
          if (ite.countryCode == item.company_country) {
            SACode1 = ite.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/detals
          path:
            "/index/tradeCompany/Trade/" +
            item.aaa_id +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.aaa_id +
            "&companyCountry=" +
            item.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            item.company_name_en +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");

      }
      if (this.tradeSelect == 'HsCode') {



        let routeData = this.$router.resolve({
     
          path:
            "/index/TradeProduct/TradeDetail/" +
            item.hsCode +
            "/tradeMap/map?id3a=" +
            item.hsCode +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");

      } if (this.tradeSelect == 'Country') {

        let routeData = this.$router.resolve({
 
          path:
            "/index/TradeCountry/TradeDetail/" +
            item.countryCode +
            "/tradeMap/map?id3a=" +
            item.countryCode +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");

      }

    },
    // 贸易模糊搜索
    querySearchAsync(queryString, cb) {
      if (queryString !== '') {
        if (this.tradeSelect == 'HsCode') {
          const params = {
            keyword: queryString,

          };
          productSearch(params)
            .then(res => {
              const data = res.data;
              if (res.code) {
                data.forEach(item => {
                  item.val = item.hsCode;
                  item.value = item.hsCode + '-' + item.hsCodeDescription;
                });

                cb(data);
              } else {
                cb([]);
              }
            })
            .catch(() => {
              cb([]);
            });
        }
        if (this.tradeSelect == 'Company') {
          const params = {
            company_name: queryString,
            page: 1,
            pageSize: 99,
            ieflag:1
          };
          searchCompany(params)
            .then(res => {
              const data = res.data;
              if (res.code) {
                data.rows.forEach(item => {
                  item.val = item.aaa_id;
                  item.value = item.company_name_en;

                  // item.val=item.value
                });
                cb(data.rows);
              } else {
                cb([]);
              }
            })
            .catch(() => {
              cb([]);
            });
        }
        if (this.tradeSelect == 'Country') {
          let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList;
          Allcountry.forEach(item => {
            item.value = item.nameEn
            item.val = item.countryCode
          })
          let SelecrCountry = queryString ? Allcountry.filter(this.createStateFilter(queryString)) : Allcountry;
          cb(SelecrCountry);
        }


      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    AIseach() {

      if (this.lockType == 2 || this.lockType == 3) {


        this.$emit("select", "ai");

      } else {
        this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');
      }
    },

    gotoOne(value) {
      window.open(value, '_blank')

    },
    clossuoDialog(value){
      this.drawer=value
    },
    getUserSimpleInfoList() {
      getUserSimpleInfo().then(res => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem('renzheng', true)
          }
          this.AvailablePoints = res.data.availablePoints
          this.ExpireDate = res.data.expiration
          this.Vips = res.data.vips
          this.lockType = res.data.lockType
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);
        }
      })
    },
    MarkRead() {
      markAllAsRead().then(res => {
        if (res.code == 200) {
          this.getNotificationListDetali()
          this.RedNews.length = 0
        }
      })
    },

    getNotificationListDetali() {
      getNotificationList().then(res => {
        if (res.code == 200) {
          this.Newlist = res.data
          if (this.Newlist.length > 0) {
            res.data.map(item => {
              if (item.hasRead == 0) {
                this.RedNews.push(item)
              }
            })
          }
        } else {
          this.Newlist = []
        }

      })
    },
    gotomessage(item) {
      this.$router.push({
        path: '/account/notifications',
        query: {
          id: item.id,
          keword: this.$route.query.keword,
        }
      });
    },
    //下拉选择国家
    gotoUSer(route) {
      if (route == '/') {
        this.$parent.loginDialog = true
      } else {
        this.$router.push({
          path: route,
          query:{
            keword: this.$route.query.keword,
          }
        });
      }

    },

    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    signOutAccount() {
      LoginOut({}).then((res) => {

        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          bus.$off("handleLogin");
          this.$router.replace({ path: "/" });
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          window.location.href = "/";
        }
      });
    },
    labelClick(label) {
      this.countryName = label;

    },
    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },
    //获取国家
    async getAllCountry() {
      let countryCode = (this.countryCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "");
      // 处理缓存问题
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("../../../static")[1];
            }
            let flag = "";
            try {
              flag = require("../../../static" + countryImg);
            } catch (error) {
                flag = "../../../static/imagev2/undefined.png";
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();
        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList")
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));
          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              // /imagev2/zanwutupian.png
              if (it.urlBanner == null) {
                countryImg = "../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../static" + countryImg);
              } catch (error) {
                flag = "../../../static/imagev2/undefined.png";
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", '');
      this.$store.dispatch("app/SetlabelCodeName", '');
      this.$store.dispatch("app/SetarchagAin", true)
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: {
            searchname: str,
            companyCountry: this.countryCode,
            keword: this.Keyword ? 2 : 1,
            companyCountryEn: this.countryCode1,
            // keword: this.$route.query.keword,
          },
        });
      } else {
        // this.$router.push({
        //   path: "/index/list/company",
        // });
      }
    },
    async getProductToplist() {
      let data = await findWhereCarouseProduct({
        startTime: "",
        endTime: "",
        start: 0,
        limit: 10000,
        name: queryParams.value.name,
        introduction: "",
        thumbnail: "",
        largeImage: "",
        content: "",
        productId: "",
      });

      if (data) {
      } else {
      }
    }, // openUrl
    openUrl(pathUrl) {
      let routeData = this.$router.resolve({
        path: pathUrl+'?keword='+this.$route.query.keword,
      });
      window.open(routeData.href, '_blank');
      this.drawer = false;
    }, // changeName
    changeName(value) {
      this.selectName = value;
    }, // handleQuery
    openAi() {
    },
    // setThemeColor() {
    //   this.$store.dispatch("app/setThemColor", "#1290C9");
    //   this.$store.dispatch("app/setSearchType", "company");
    // },
 
  },
  mounted(){

      this.selectLanguage({countryCode:this.$store.state.app.lang})
    this.$i18n.locale=this.$store.state.app.lang
         this.$store.dispatch("app/setLang", this.$i18n.locale)
   
     if(this.$route.query.Moudles == 'Trade'){
      this.tradeSelect=this.$route.query.Tradechannel

     }
  }

};
</script>
<style scoped>

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.uBmamJ5 {
  display: flex;
  align-items: center;
  height: 100%;
  height: 6.28rem;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  justify-content: space-between;
  position: relative;
}


.u6c4a8 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0rem;
  padding-bottom: 0rem;
  padding-right: 0rem;
}

.ub36bc {
  /* display: flex;
  align-items: center; */
  /* margin-right: 3rem; */
  /* flex: auto; */
  /* margin-right: 5em; */
}

.u5a174 {
  display: flex;
  align-items: center;
  height: 2rem;
  width: 19rem;
  /* margin-left: 0.91rem; */
}

.u96216 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  opacity: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.21);
  margin-right: 1.428rem;
}

.u51469 {
  display: flex;
}

.uVRU8uU {
  margin-right: 0.5rem;
  fill: #fff;
}

.uef8b8 {
  width: 5rem;
  font-size: 1.1428575rem;
}

.topBarBox {
  width: 50.28571428571429rem;
  height: 3.857rem;
}

.u52ab1 {
  display: flex;
  align-items: center;
  width: 0;
  height: 3.857142857142857em;
  /* height: 3.857rem; */
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  /* margin-right: 7.07em; */
  /* flex: auto; */
  width: 60.2857143rem;
  padding-left: 1.42857143rem;
  padding-top: 0.8571428571428571rem;
  padding-right: 0.8571428571428571rem;
  padding-bottom: 0.8571428571428571rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
  margin-right: 0rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

@media (min-width: 1441px) and (max-width: 1770px) {
  .u52ab1 {
    width: 48% !important;
  }
}

.uTh6lQG {
  display: flex;
  align-items: center;
  height: 3rem;
}

.ua2717 {
  display: flex;
  align-items: center;
  /* width: 7.2em; */
  height: 2.5rem;
  box-sizing: border-box;
}

.uihjfMt {
  color: #1a2332;
  margin-right: 1.0714285714285714rem;
  font-size: 1rem;
}

.ucff1d {
  display: flex;
  box-sizing: border-box;
  padding-left: 0.1rem;
  padding-top: 0.1rem;
  padding-right: 0.1rem;
  padding-bottom: 0.1rem;
  border-style: dashed;
  border-color: #9b9b9b;
  border-width: 0.07142857142857142rem;
}

.u0eb4b {
  height: 2.142rem;
}

.uc6fcf {
  display: flex;
  margin-right: 0.5rem;
  flex: auto;
  font-size: 1rem;
  flex-wrap: wrap;
  width: 6.714285714285714rem;
}

.uiZXktJ {
  margin-right: 0.5rem;
}

.u4229a {
  height: 2.142857142857143rem;
  margin-right: 0.5rem;
  border-right-style: solid;
  border-right-width: 0.07142857142857142rem;
  border-right-color: #DDDDDD;
}

.u6e410 {
  width: 45%;
  flex: auto;
}

.u0fcfc {
  width: 90%;
  height: 2.142rem;
  line-height: 2.142rem !important;
  margin-right: 0.5rem;
  flex: none;
  outline: none;
  border: none;
  box-shadow: none;
  font-size: 1.1428571428571428rem;
}

.u0fcfc /deep/ .el-input__inner {
  width: 100%;
  height: 100%;
  line-height: 2.142rem !important;

}

.u812f9 {
  display: block;
  width: 7.928rem;
  min-width: 7.857142857142857rem;
}

.u8dab7 {
  color: #8497ab;
  font-size: 1.1428571428571428rem;
}

.udd32b {
  margin-right: 0.2857142857142857rem;
}

.u1ffe9 {
  display: none;
}

.u942df {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: none;
  margin-right: 1.4285714285714286rem;
  margin-left: 7.428571428571429rem;
}

.top_menu_icon {
  margin-right: 2.14rem;
  fill: white;
}

.uQOJMWu {
  display: none;
}

.u1ba31 {
  width: 3.5714285714285716rem;
  height: 3.5714285714285716rem;
  overflow: hidden;
  border-radius: 50%;
}

.u1337c {
  display: flex;
  width: 21rem;
  background-color: rgb(237, 233, 233);
  padding-left: 0.5rem;
}

.u50ede {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4285714285714284rem;
  height: 2.4285714285714284rem;
  background: #1290c9;
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  margin-top: 2em;
}

.ud903b {
  padding-top: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.2rem;
  flex: auto;
}

.u7bffa {
  display: flex;
  justify-content: space-between;
}

.uF3Xlzl {
  font-size: 1.4285714285714286rem;
}

.ue08f5 {
  color: rgb(118, 118, 118);
  font-size: 1.1428571428571428rem;
}

.u4defb {
  color: rgb(35, 138, 204);
  font-size: 1.1428571428571428rem;
}

.ut7Z1e7 {
  padding-top: 1.4285714285714286rem;
  padding-bottom: 1.4285714285714286rem;
}

.uc68vlP {
  margin-right: 1.1428571428571428rem;
}

.u9qMull {
  font-size: 1.285714285714286rem;
  /* margin-top: 1.7142857142857142rem;
  margin-bottom: 1.7142857142857142rem; */
  width: 100%;
  display: inline-block;
}

.uiV7d8r {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uE952fV {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uLNvNN4 {
  margin-right: 1rem;
  margin-left: 1rem;
}

.u6srk61 {
  margin-right: 1rem;
  margin-left: 1rem;
}

.udbf23 {
  height: 0.07142857142857142rem;
  margin-right: 0.7142857142857143rem;
  background: #cccccc;
  margin-left: 1rem;
}

.uaeb42 {
  margin-right: 2.142857142857143rem;
  margin-left: 2.142857142857143rem;
}

.u13OR2m {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uuXabem {
  line-height: 5rem;
}

.u6f58a {
  /* margin-right: 1.357em; */
}



.menu_box_1 path {
  display: flex;
  align-items: center;
  width: 50%;
  margin-bottom: 2rem;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  fill: #1290c9;
}

.uVRU8uU path {
  fill: #fff;
}

.u0fcfc input {
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  border-style: none;
}

.uJuUEnk i {
  color: rgb(255, 255, 255);
}

.uJuUEnk input {
  background-color: rgb(35, 138, 204);
  color: rgb(255, 255, 255);
}

.gaddc3 {
  display: flex;
}

.search_left .head_pro_cas /deep/ .el-input__inner {
  background-color: transparent;
  /* height: 3em; */
  /* opacity: 0; */
  font-size: 1rem !important;
}

.search_left .head_pro_cas /deep/ .el-input__inner ::input-placeholder {
  color: black;
}

/deep/ .el-input__suffix {
  right: -1.6428571428571428rem !important;
}
.search_left_Trade /deep/ .el-input__suffix {
  right: 20px !important;
}
.head_pro_cas /deep/ .el-input__suffix {
  right: 0.2857142857142857rem !important;
}

.head_box {
  width: 100%;
  height: 6.428571428571429rem;
  background: #1290c9;
}

.search2 {
  border: 0.07142857142857142rem solid red !important;
  transition: border-color 0.3s ease-in-out;
  /* color: #022955; */
}

/* 搜索 */
.head_search {
  width: 67.85714285714286rem;
  height: 3.857142857142857rem;
  background: #ffffff;
  border-radius: 1em;
  border: 0.07142857142857142rem solid #DDDDDD;
  color: #022955;
  margin-left: 4.428571428571429rem;
}

.search_right {
  flex: 1;
  position: relative;
}

.search_input {
  width: 100%;
  word-wrap: break-word;
  line-height: 2.142857142857143rem;
  outline: none;
  border: none;
  padding: 0 1.4285714285714286rem;
  font-size: 1.14285714rem;
}

.search_btn {
  width: 4.642857142857143rem;
  height: 3.857142857142857rem;
  cursor: pointer;
}

.search_btn img {
  width: 1.7142857142857142rem;
}

/* 选择下拉 */
.search_left {
  width: 11.428571428571429rem;
  height: 2.142857142857143rem;
  /* height: 100%; */
  position: relative;
  display: flex;
  align-items: center;
}
.search_left_Trade{
    width: 9rem !important;

}

.search_left::after {
  content: "";
  position: absolute;
  right: 0.21428571428571427rem;
  top: 0em;
  width: 0.07142857142857142rem;
  height: 2.142857142857143rem;
  background-color: #dddddd;
}

.search_left /deep/ .el-input__inner {
  border: none;
  font-size: 1.1428571428571428rem;

}

/deep/ .el-input__inner {
  padding-right: 0em !important;
  padding-left: 0.7142857142857143rem !important;

}

.country_flag {
  display: flex;
  align-items: center;
  height: 2.142857142857143rem;
  width: 3.142857142857143rem
}

.country_flag_img {
  width: 2.7142857142857144rem;
  height: 1.5714285714285714rem;
  margin: 1.0714285714285714rem 0.14285714285714285rem 1.0714285714285714rem 0rem;
  box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem rgba(0, 0, 0, 0.2);
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

.search_left .el-select {
  position: absolute;
  /* top: 0; */
  width: 9.285714285714286rem;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  /* height: 3.7142857142857144em; */
  /* opacity: 0; */
  font-size: 1.1428571428571428rem;
  white-space: nowrap;
  padding-left: 0rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 3rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #022955;
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
  /* font-weight: 600; */
}

.sel_place {
  width: 100%;
  line-height: 3.7142857142857144rem;
  padding-left: 1.4285714285714286rem;
  display: inline-block;
  font-size: 1rem;
}

.el-select-dropdown__wrap {
  max-height: 26.785714285714285rem !important;
}

/* .el-cascader__dropdown{
z-index: 9999999 !important;
} */
.el-select-dropdown__list {
  padding: 0.7142857142857143rem 0 !important;
}

.search_sel_container {
  width: 85.71428571428571rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left {
  /* width: 17.142857142857142rem; */
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0.07142857142857142rem;
  background-color: #eee;
}

/deep/ .el-popper {
  z-index: 999999 !important;

}

.el-cascader__dropdown {
  z-index: 999999 !important;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  margin-right: 0.07142857142857142rem;
  padding: 0 0.571428571428571rem;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  /* line-height: 3rem; */
  margin-bottom: 0.5714285714285714rem;
  display: flex;
  align-items: center;
  padding: 0 0.7142857142857143rem !important;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #F5F5F5;
}

.el-select-dropdown__item:hover {
  background: #F5F5F5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 1.1428571428571428rem;
  margin-right: 10px;
}



.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #F5F5F5
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #F5F5F5;
  /* border-radius: 1rem; */
  border: 1px solid #1290c9;
}


.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}



.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.1428571428571428rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}



/deep/ .el-dropdown-menu__item {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 2.57rem;
}

/deep/ .el-badge__content--warning {
  background-color: #F56C6C;
  top: 1.2142857142857142rem !important;
  right: -0.35714285714285715rem !important;
  width: 1.7857142857142858rem;
  height: 1.7857142857142858rem;
  border-radius: 50%;
  font-size: 0.8571428571428571rem;
  padding: 0rem !important;
  line-height: 1.7857142857142858rem !important;
}

.history_box-head {
  font-size: 1.285714285714286rem;
  width: 100%;

}

.history_box-headborder {
  border-bottom: 0.07142857142857142rem solid #DDDDDD;
  padding-bottom: 0.7142857142857143rem;


}

.item_title {
  padding: 1.285714285714286rem 0rem;
  /* background-color: #f5f5f5; */
  /* margin-bottom: 0.7142857142857143em; */
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

/deep/ .el-popover {
  padding: 1.285714285714286rem !important;
}

.messageimg {
  height: 2.857142857142857rem;
  width: 2.857142857142857rem;
  border-radius: 50%;
}

.item_cont_txt {
  padding: 0.7142857142857143rem;
  border-radius: 0.42857142857142855rem;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  background-color: #f5f5f5;
  margin-top: 1em;
}

.head-text {
  font-family: 'DMSans Bold';
  font-size: 1.2857142857142858rem !important;
  text-align: left;
  font-style: normal;
  color: #1a2332;
  line-height: 1.4285714285714286rem;
}

.icon {
  /* margin-right: 0.7142857142857143em; */
}

.icon-time {
  font-size: 1rem;
  line-height: 1.6428571428571428rem;
  color: #999999;
  margin-top: 0.5714285714285714rem;
}

.message-right {
  margin-left: 1.4285714285714286rem;
}

.history_box_bottom {
  position: absolute;
  bottom: 0rem;
  padding-top: 1rem;
  background: #ffffff;
  width: 100%;
  border-top: 0.07142857142857142rem solid #dddddd;
}

.right-blue {
  margin-top: 0.5rem;
  width: 0.7142857142857143rem;
  height: 0.7142857142857143rem;
  background: #F56C6C;
  border-radius: 50%;
  padding-left: 0.7142857142857143rem;
}

.srcviewslayoutheadervuecssEnd {}

.icontwo {
  margin-right: 0.7142857142857143rem;
}

.postiverelatibve {
  position: relative;
}

.postiveaboust {
  position: absolute;
  right: -1rem;
  top: 2.7857142857142856rem;
}

.avatar {
  width: 3.5714285714285716rem;
  height: 3.5714285714285716rem;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  font-size: 2.28571429rem;
  line-height: 3.5714285714285716rem;
  text-align: center;
  color: #a2a9b0;
  overflow: hidden;
}

.avatarnologin {
  width: 3.4285rem;
  height: 3.4285rem;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;

  line-height: 3.5714285714285716rem;
  text-align: center;
  color: #a2a9b0;
  /* overflow: hidden; */
}

.avatar_content {
  font-size: 2.2857142857142856rem;
  cursor: pointer;
}

.account-left-right {
  margin-left: 1.5714285714285714rem;
}

.account-left-right h3 {
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 1.7142857142857142rem;
}

.account-left {
  margin-bottom: 2.142857142857143rem;
}

.account-left-right h4 {
  font-size: 1.1428571428571428rem;
  color: #666666;
  margin-top: 0.42857142857142855rem;
}

.progress {
  margin-top: 1.4285714285714286rem;
  margin-bottom: 0.7142857142857143rem;
}

.ExpireDate {
  font-size: 14px !important;
  color: #8497AB;
  line-height: 1.1428571428571428rem;
  /* padding-bottom: 1.4285714285714286em; */
}

.ExpireDate :nth-of-type(1) {
  border-bottom: 0.07142857142857142rem solid #dddddd;

}

.Available {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  margin-top: 1.1428571428571428rem;
  margin-bottom: 1.4285714285714286rem;
}

.henggang {
  height: 0.07142857142857142rem;
  margin: 0.21428571428571427rem 1.4285714285714286rem;
  background-color: #dddddd;
}

@media (min-width: 960px) and (max-width: 1500px) {

  /* 在此处添加样式 */
  /* .ub36bc,
  .top_menu_icon,
  .top_menu_icon,
  .u6c4a8,
  .usRlj2Q {
    margin-right: 1em;
  }

  .uGuqXzB {
    margin-left: 0em;
  }

  .ueqCkmp {
    margin-left: 0em;
  }

  .usRlj2Q {
    margin-left: 0em !important;
  }

  .u52ab1 {
     margin-right: 2em; 
  }

  .search_left {
    width: 10.714285714285714em;
  }

  .search_left /deep/ .el-select {
    width: 75%;
  }

  /deep/ .el-badge__content.is-fixed {
    right: 1.4285714285714286em !important;
  }

  .history_box-head /deep/ .el-badge__content.is-fixed {
    right: 0em !important;
  }*/
}

/deep/ .el-badge__content.is-fixed {
  right: 3em;
  transform: translateY(-50%) translateX(100%) scale(0.9);
  line-height: 1.1428571428571428rem;
}

.history_box {
  height: 21.428571428571427rem;
  overflow-y: auto;
  padding-bottom: 2.857142857142857rem;
}

.u0427c {
  display: flex;
  align-items: center;
  height: 2.4285714285714284rem;
  padding-left: 0.7142857142857143rem;
  padding-right: 0.7142857142857143rem;
  padding-top: 0.35714285714285715rem;
  padding-bottom: 0.35714285714285715rem;
  box-sizing: border-box;
  border: 0.07142857142857142rem solid rgba(255, 255, 255, 0.5);
  border-radius: 1.1428571428571428rem;
}

.u84443 {
  margin-right: 0.35714285714285715rem;
  color: #ffffff;
  font-size: 1.1428571428571428rem;
  text-align: center;
  line-height: 1.2857142857142858rem;
  font-style: normal;
}

.ubbf89 {
  width: 1.5714285714285714rem;
  height: 1.5714285714285714rem;
  /* background-color: rgba(255, 255, 255, 1); */
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  overflow-y: hidden;
  overflow-x: hidden;
}

.flex_box {
  position: relative;
}

.right-blue {
  position: absolute;
  right: 0em;
}

.u606de {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  padding: 0.7142857142857143rem 0rem;
  font-size: 1.285714285714286rem;
}

#gfdd55 {
  height: 1.7857142857142858rem;
}

.activecolor {
  color: #1290c9;
}

.marginu6c4a8 {
  margin-left: 1.0714285714285714rem;
}



/deep/ .el-badge__content {

  min-height: 1rem;
  min-width: 1.2857142857142858rem;
  border-radius: 50%;
  padding: 0rem;
}

.sel_box {
  z-index: 9999 !important;
}
.aaaa /deep/ .el-switch__core{
 border-color: rgb(142, 134, 221) !important;
 background-color: rgb(142, 134, 221) !important
}
.bbbb /deep/ .el-switch__core{
 border-color: #1290C9 !important;
 background-color: #1290C9 !important
}
.headImg{
  height: 40px;
  /* width: 50px; */
}
</style>